import { defineMessage } from 'services/localization';

export const messages = {
    narration: defineMessage('narration'),
    date: defineMessage('date'),
    showOnCashBasisReports: defineMessage('show_journal_on_cash_basis_reports'),
};
